import React from "react";
import { useNavigate } from "react-router-dom";

type PropsType = {
  hospitalName?: String;
  vetName?: String;
  email?: String;
  _id?: String;
};

const CareTeamRow = ({ hospitalName, vetName, email, _id }: PropsType) => {
  const navigate = useNavigate();
  return (
    <>
      <hr className="tw-w-[70%] tw-mt-2  tw-border-black tw-opacity-none" />
      <div className="tw-flex tw-items-center tw-justify-between tw-p-2">
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {hospitalName !== "" ? hospitalName : "None"}
        </div>
        <div className="tw-flex-1  tw-text-xl  tw-text-[#000000] tw-font-normal">
          {vetName !== "" ? vetName : "None"}
        </div>
        <div className="tw-flex-1 tw-truncate tw-text-xl tw-text-[#000000] tw-font-normal">
          {email !== "" ? email : "None"}
        </div>

        <div className="tw-flex tw-justify-center tw-flex-1">
          <button
            className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-darkRed tw-py-2 tw-px-8 tw-rounded-md"
            onClick={() => {
              navigate(`/user/care-team/contact-info/${_id}`);
            }}
          >
            Contact details
          </button>
        </div>
      </div>
    </>
  );
};

export default CareTeamRow;
